export default function ChapterDetail3(props) {
  document.title = props.text + " | Arisu";

	return (
    <>
      <p className="indent-8">
        They were indeed a queer-looking party that assembled on the bank—the
        birds with draggled feathers, the animals with their fur clinging close to
        them, and all dripping wet, cross, and uncomfortable.
      </p>
      <p className="indent-8">
        The first question of course was, how to get dry again: they had a consultation
        about this, and after a few minutes it seemed quite natural to Alice to find
        herself talking familiarly with them, as if she had known them all her life.
        Indeed, she had quite a long argument with the Lory, who at last turned sulky,
        and would only say, “I am older than you, and must know better;”
        and this Alice would not allow without knowing how old it was, and, as the Lory
        positively refused to tell its age, there was no more to be said.
      </p>
      <p className="indent-8">
        At last the Mouse, who seemed to be a person of authority among them, called
        out, “Sit down, all of you, and listen to me! <i>I’ll</i> soon make
        you dry enough!” They all sat down at once, in a large ring, with the
        Mouse in the middle. Alice kept her eyes anxiously fixed on it, for she felt
        sure she would catch a bad cold if she did not get dry very soon.
      </p>
      <p className="indent-8">
        “Ahem!” said the Mouse with an important air, “are you all
        ready? This is the driest thing I know. Silence all round, if you please!
        ‘William the Conqueror, whose cause was favoured by the pope, was soon
        submitted to by the English, who wanted leaders, and had been of late much
        accustomed to usurpation and conquest. Edwin and Morcar, the earls of Mercia
        and Northumbria—’”
      </p>
      <p className="indent-8">
        “Ugh!” said the Lory, with a shiver.
      </p>
      <p className="indent-8">
        “I beg your pardon!” said the Mouse, frowning, but very politely:
        “Did you speak?”
      </p>
      <p className="indent-8">
        “Not I!” said the Lory hastily.
      </p>
      <p className="indent-8">
        “I thought you did,” said the Mouse. “—I proceed.
        ‘Edwin and Morcar, the earls of Mercia and Northumbria, declared for him:
        and even Stigand, the patriotic archbishop of Canterbury, found it
        advisable—’”
      </p>
      <p className="indent-8">
        “Found <i>what</i>?” said the Duck.
      </p>
      <p className="indent-8">
        “Found <i>it</i>,” the Mouse replied rather crossly: “of
        course you know what ‘it’ means.”
      </p>
      <p className="indent-8">
        “I know what ‘it’ means well enough, when <i>I</i> find a
        thing,” said the Duck: “it’s generally a frog or a worm. The
        question is, what did the archbishop find?”
      </p>
      <p className="indent-8">
        The Mouse did not notice this question, but hurriedly went on,
        “‘—found it advisable to go with Edgar Atheling to meet
        William and offer him the crown. William’s conduct at first was moderate.
        But the insolence of his Normans—’ How are you getting on now, my
        dear?” it continued, turning to Alice as it spoke.
      </p>
      <p className="indent-8">
        “As wet as ever,” said Alice in a melancholy tone: “it
        doesn’t seem to dry me at all.”
      </p>
      <p className="indent-8">
        “In that case,” said the Dodo solemnly, rising to its feet,
        “I move that the meeting adjourn, for the immediate adoption of more
        energetic remedies—”
      </p>
      <p className="indent-8">
        “Speak English!” said the Eaglet. “I don’t know the
        meaning of half those long words, and, what’s more, I don’t believe
        you do either!” And the Eaglet bent down its head to hide a smile: some
        of the other birds tittered audibly.
      </p>
      <p className="indent-8">
        “What I was going to say,” said the Dodo in an offended tone,
        “was, that the best thing to get us dry would be a Caucus-race.”
      </p>
      <p className="indent-8">
        “What <i>is</i> a Caucus-race?” said Alice; not that she wanted
        much to know, but the Dodo had paused as if it thought that <i>somebody</i>
        ought to speak, and no one else seemed inclined to say anything.
      </p>
      <p className="indent-8">
        “Why,” said the Dodo, “the best way to explain it is to do
        it.” (And, as you might like to try the thing yourself, some winter day,
        I will tell you how the Dodo managed it.)
      </p>
      <p className="indent-8">
        First it marked out a race-course, in a sort of circle, (“the exact shape
        doesn’t matter,” it said,) and then all the party were placed along
        the course, here and there. There was no “One, two, three, and
        away,” but they began running when they liked, and left off when they
        liked, so that it was not easy to know when the race was over. However, when
        they had been running half an hour or so, and were quite dry again, the Dodo
        suddenly called out “The race is over!” and they all crowded round
        it, panting, and asking, “But who has won?”
      </p>
      <p className="indent-8">
        This question the Dodo could not answer without a great deal of thought, and it
        sat for a long time with one finger pressed upon its forehead (the position in
        which you usually see Shakespeare, in the pictures of him), while the rest
        waited in silence. At last the Dodo said, “<i>Everybody</i> has won, and
        all must have prizes.”
      </p>
      <p className="indent-8">
        “But who is to give the prizes?” quite a chorus of voices asked.
      </p>
      <p className="indent-8">
        “Why, <i>she</i>, of course,” said the Dodo, pointing to Alice with
        one finger; and the whole party at once crowded round her, calling out in a
        confused way, “Prizes! Prizes!”
      </p>
      <p className="indent-8">
        Alice had no idea what to do, and in despair she put her hand in her pocket,
        and pulled out a box of comfits, (luckily the salt water had not got into it),
        and handed them round as prizes. There was exactly one a-piece, all round.
      </p>
      <p className="indent-8">
        “But she must have a prize herself, you know,” said the Mouse.
      </p>
      <p className="indent-8">
        “Of course,” the Dodo replied very gravely. “What else have
        you got in your pocket?” he went on, turning to Alice.
      </p>
      <p className="indent-8">
        “Only a thimble,” said Alice sadly.
      </p>
      <p className="indent-8">
        “Hand it over here,” said the Dodo.
      </p>
      <p className="indent-8">
        Then they all crowded round her once more, while the Dodo solemnly presented
        the thimble, saying “We beg your acceptance of this elegant
        thimble;” and, when it had finished this short speech, they all cheered.
      </p>
      <p className="indent-8">
        Alice thought the whole thing very absurd, but they all looked so grave that
        she did not dare to laugh; and, as she could not think of anything to say, she
        simply bowed, and took the thimble, looking as solemn as she could.
      </p>
      <p className="indent-8">
        The next thing was to eat the comfits: this caused some noise and confusion, as
        the large birds complained that they could not taste theirs, and the small ones
        choked and had to be patted on the back. However, it was over at last, and they
        sat down again in a ring, and begged the Mouse to tell them something more.
      </p>
      <p className="indent-8">
        “You promised to tell me your history, you know,” said Alice,
        “and why it is you hate—C and D,” she added in a whisper,
        half afraid that it would be offended again.
      </p>
      <p className="indent-8">
        “Mine is a long and a sad tale!” said the Mouse, turning to Alice,
        and sighing.
      </p>
      <p className="indent-8">
        “It <i>is</i> a long tail, certainly,” said Alice, looking down
        with wonder at the Mouse’s tail; “but why do you call it
        sad?” And she kept on puzzling about it while the Mouse was speaking, so
        that her idea of the tale was something like this:—
      </p>
      <div className="grid justify-center">
        <p className="indent-16 mt-2">“Fury said to a</p>
        <p className="indent-12">mouse, That he</p>
        <p className="indent-8">met in the</p>
        <p className="indent-4">house,</p>
        <p className="mx-2">‘Let us</p>
        <p className="indent-4">both go to</p>
        <p className="indent-8">law: <i>I</i> will</p>
        <p className="indent-12">prosecute</p>
        <p className="indent-16"><i>you</i>.—Come,</p>
        <p className="indent-20">I’ll take no</p>
        <p className="indent-24">denial; We</p>
        <p className="indent-20">must have a</p>
        <p className="indent-16">trial: For</p>
        <p className="indent-12">really this</p>
        <p className="indent-8">morning I’ve</p>
        <p className="indent-4">nothing</p>
        <p className="mx-2">to do.’</p>
        <p className="indent-4">Said the</p>
        <p className="indent-8">mouse to the</p>
        <p className="indent-12">cur, ‘Such</p>
        <p className="indent-16">a trial,</p>
        <p className="indent-20">dear sir,</p>
        <p className="indent-24">With</p>
        <p className="indent-20">no jury</p>
        <p className="indent-16">or judge,</p>
        <p className="indent-12">would be</p>
        <p className="indent-8">wasting</p>
        <p className="indent-12">our</p>
        <p className="indent-16">breath.’</p>
        <p className="indent-20">‘I’ll be</p>
        <p className="indent-24">judge, I’ll</p>
        <p className="indent-28">be jury,’</p>
        <p className="indent-32">Said</p>
        <p className="indent-36">cunning</p>
        <p className="indent-32">old Fury:</p>
        <p className="indent-28">‘I’ll</p>
        <p className="indent-32">try the</p>
        <p className="indent-36">whole</p>
        <p className="indent-40">cause,</p>
        <p className="indent-36">and</p>
        <p className="indent-32">condemn</p>
        <p className="indent-28">you</p>
        <p className="indent-24">to</p>
        <p className="indent-20 mb-2">death.’”</p>
      </div>
      <p className="indent-8">
        “You are not attending!” said the Mouse to Alice severely.
        “What are you thinking of?”
      </p>
      <p className="indent-8">
        “I beg your pardon,” said Alice very humbly: “you had got to
        the fifth bend, I think?”
      </p>
      <p className="indent-8">
        “I had <i>not!</i>” cried the Mouse, sharply and very angrily.
      </p>
      <p className="indent-8">
        “A knot!” said Alice, always ready to make herself useful, and
        looking anxiously about her. “Oh, do let me help to undo it!”
      </p>
      <p className="indent-8">
        “I shall do nothing of the sort,” said the Mouse, getting up and
        walking away. “You insult me by talking such nonsense!”
      </p>
      <p className="indent-8">
        “I didn’t mean it!” pleaded poor Alice. “But
        you’re so easily offended, you know!”
      </p>
      <p className="indent-8">
        The Mouse only growled in reply.
      </p>
      <p className="indent-8">
        “Please come back and finish your story!” Alice called after it;
        and the others all joined in chorus, “Yes, please do!” but the
        Mouse only shook its head impatiently, and walked a little quicker.
      </p>
      <p className="indent-8">
        “What a pity it wouldn’t stay!” sighed the Lory, as soon as
        it was quite out of sight; and an old Crab took the opportunity of saying to
        her daughter “Ah, my dear! Let this be a lesson to you never to lose
        <i>your</i> temper!” “Hold your tongue, Ma!” said the young
        Crab, a little snappishly. “You’re enough to try the patience of an
        oyster!”
      </p>
      <p className="indent-8">
        “I wish I had our Dinah here, I know I do!” said Alice aloud,
        addressing nobody in particular. “She’d soon fetch it back!”
      </p>
      <p className="indent-8">
        “And who is Dinah, if I might venture to ask the question?” said
        the Lory.
      </p>
      <p className="indent-8">
        Alice replied eagerly, for she was always ready to talk about her pet:
        “Dinah’s our cat. And she’s such a capital one for catching
        mice you can’t think! And oh, I wish you could see her after the birds!
        Why, she’ll eat a little bird as soon as look at it!”
      </p>
      <p className="indent-8">
        This speech caused a remarkable sensation among the party. Some of the birds
        hurried off at once: one old Magpie began wrapping itself up very carefully,
        remarking, “I really must be getting home; the night-air doesn’t
        suit my throat!” and a Canary called out in a trembling voice to its
        children, “Come away, my dears! It’s high time you were all in
        bed!” On various pretexts they all moved off, and Alice was soon left
        alone.
      </p>
      <p className="indent-8">
        “I wish I hadn’t mentioned Dinah!” she said to herself in a
        melancholy tone. “Nobody seems to like her, down here, and I’m sure
        she’s the best cat in the world! Oh, my dear Dinah! I wonder if I shall
        ever see you any more!” And here poor Alice began to cry again, for she
        felt very lonely and low-spirited. In a little while, however, she again heard
        a little pattering of footsteps in the distance, and she looked up eagerly,
        half hoping that the Mouse had changed his mind, and was coming back to finish
        his story.
      </p>
    </>
  )
}